import { createContext, useContext } from 'react';
import { DEFAULT_CARDS_PER_PAGE, DEFAULT_MAX_CARDS_PER_COLUMN } from './constants';
import emptyFunction from 'react-utils/emptyFunction';
// @ts-expect-error missing CardComponent
export const defaultConfigs = {
  cardsPerPage: DEFAULT_CARDS_PER_PAGE,
  maxCardsPerColumn: DEFAULT_MAX_CARDS_PER_COLUMN,
  onCardClick: emptyFunction,
  onColumnChange: undefined,
  //need undefined to turn feature off it not in use
  isDragInProgress: false,
  hideQuerySelection: false,
  setIsDragInProgress: emptyFunction,
  useReskin: false
};
export const ConfigContext = /*#__PURE__*/createContext(defaultConfigs);
export const useConfigs = () => useContext(ConfigContext);